import UAParser from 'ua-parser-js';

export const getDevice = (useragent: string) => {
  const parser = new UAParser(useragent);
  return parser.getDevice()?.type ?? 'desktop';
};
